import { ResponseStatus } from '@revenuemarket/http';
import { Toast } from '@revenuemarket/ui';

import { useEditCompanySpecificCategories } from '~hooks/queries/categories/query';
import { useDemoAwareCompanyId } from '~hooks/useDemoAwareCompanyId';

import DescriptionTextArea from './common/component/DescriptionTextArea';

interface TextAreaProps {
  categoryId: number;
  id: number;
  name: string;
  description?: string;
  parentId: number | null;
}

export const CATEGORY_DESCRIPTION_MAX_LENGTH_INFO = '100자 까지만 입력할 수 있어요.';
export const CATEGORY_DESCRIPTION_MAX_LENGTH = 100;

const CategoryDescriptionTextArea: React.FC<TextAreaProps> = ({
  name,
  categoryId,
  id,
  description,
  parentId,
}) => {
  const { companyId } = useDemoAwareCompanyId();

  const { mutateAsync: editCategories, isLoading } = useEditCompanySpecificCategories();

  const onSave = async (descriptionInput: string) => {
    const response = await editCategories({
      companyId,
      categoryId,
      id,
      request: {
        name,
        description: descriptionInput,
        parentId: parentId ?? undefined,
      },
    });

    if (response.Status === ResponseStatus.SUCCESS) {
      Toast.success('계정 설명이 변경되었습니다.');
    } else {
      Toast.error('계정 설명 변경에 실패했습니다.');
    }
  };

  return <DescriptionTextArea description={description} isLoading={isLoading} onSave={onSave} />;
};

export default CategoryDescriptionTextArea;
